import { Google, Pixall } from 'reaxl-analytics-handlers';

export async function cpoFilterTileEventClick({
    data = {},
    dataLayer,
}, option) {
    const { cmp, spt, epn, eventSource = 'oem', makeCode, filterValues } = data;

    const extra = {
        cmp,
        epn,
        es: eventSource,
        et: 'click',
        spt,
    };

    Pixall.sendClickEvent({
        eventSource,
        eventType: 'click',
        label: cmp,
        vendor: epn,
        make: makeCode,
        hasListingType: false,
        ...(eventSource === 'button' ? { filterValues } : {}),
    }, dataLayer, option);

    Google.sendClickEvent({
        eventElement: 'partner',
        eventResult: `certified::${makeCode}`,
        eventData: {
            vehicle: {
                clickType: '',
                listingPosition: '',
            },
        },
    }, option);

    return extra;
}
